import { CellClassParams } from '@ag-grid-community/core';

export const getCellClassForGroups = (params: CellClassParams) => {
  const allColumns = params.api.getAllGridColumns();
  const isCurrentColumnLast =
    allColumns[allColumns.length - 1].getColId() === params.column.getColId();

  if (isCurrentColumnLast) {
    return [];
  }

  const siblingColumns = params.column.getParent().getDisplayedChildren() || [];
  const isLastColumn = siblingColumns[siblingColumns.length - 1] === params.column;

  if (isLastColumn) {
    return ['border-right'];
  }

  return [];
};
